"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [pulseActive, setPulseActive] = useState(false);
  const pulseIntervalRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!prefersReducedMotion) {
      pulseIntervalRef.current = setInterval(() => {
        setPulseActive(true);
        setTimeout(() => setPulseActive(false), 600);
      }, 8000);
    }
    return () => {
      if (pulseIntervalRef.current) {
        clearInterval(pulseIntervalRef.current);
      }
    };
  }, []);
  return <section ref={ref} className={`relative w-full min-h-screen m-0 p-0 flex items-center justify-center overflow-hidden transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute top-0 left-0 right-0 h-16 z-[1] bg-transparent"></div>

      {}
      <div className="absolute inset-0 z-0 bg-primary-dark bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/image_fwcv4mid.png)] brightness-90"></div>
      <div className="absolute inset-0 z-[5] bg-primary-dark/50"></div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 z-[1] bg-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-16 z-[2] bg-primary-dark/30"></div>

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h1 className="text-4xl font-display font-bold mb-4 leading-tight !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">
          Helping Students Build&nbsp;
          <span style={{
          color: "rgb(255, 255, 255)"
        }}>
            Confidence, Focus, and Strong Exam Results
          </span>
        </h1>
        <p className="text-lg mb-8 max-w-2xl mx-auto !text-[hsl(0,0%,100%)] md:text-xl lg:text-2xl">We are a Premium Online Tutoring company that combines academic tutoring coaching so students don't just revise more, they learn how to learn and perform under pressure.&nbsp;</p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <Link to="/ContactPage">
            <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs rounded-md has-[>svg]:px-4 bg-secondary shadow-medium font-semibold text-base px-8 py-4 h-auto transition-all duration-[var(--duration-medium)] scale-100 !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary-hover active:bg-secondary-active md:text-lg" style={{
            transform: pulseActive ? "scale(1.03)" : "scale(1)"
          }}>
              Book a Free 15‑Minute Parent Consultation
            </Button>
          </Link>

          <Link to="/ServicesPage">
            <Button variant="outline" size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs rounded-md has-[>svg]:px-4 bg-background/20 border-foreground-dark/40 backdrop-blur-sm font-semibold text-base px-8 py-4 h-auto transition-all duration-[var(--duration-medium)] !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-background/30 hover:text-foreground md:text-lg">
              View Our Programmes
            </Button>
          </Link>
        </div>

        <p className="text-sm font-sans !text-[hsl(48,96%,53%)]">
          UK‑based • Qualified teachers • DBS‑checked • Parent progress updates
        </p>
      </div>
    </section>;
}